import React from "react";
import Header from "../components/Header/header";
import SecondHeader from "../components/Header/secondheader";
import Footer from "../components/Footer/index";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  IndiaAIFestivalComponents,
  IndiaAIFestivalTarget,
  IndiaAIFestivalTimeline,
  IndiaAIFestivalSpecialAwards,
  IndiaAIFestivalHowToParticipate,
  IndiaAIFestivalBanner,
  IndiaAIFestivalContact,
  IndiaAIFestivalMainAwards,
  IndiaAIFestivalSubmissionGuidelines,
  IndiaAIFestivalGuidelines,
  IndiaAIFestivalProjectShowcase,
  IndiaAIFestivalDeadlineNotice,
  IndiaAIFestivalOpportunity,
  IndiaAIFestivalRedirectionPopUp,
} from "../components/IndiaAIFestival2025";
import {
  SUBMISSION_END_TIMES,
  isSubmissionOpen,
} from "../utils/impactFestival";
import { ATLTinckerpreneurDisclaimer } from "../components/ATLTinckerpreneur";
import { formatDateToDDMMMYYYY } from "../utils";
import { BlinkingNode, LanguageSwitcher } from "../components/shared";

const Section = styled.div`
  margin-top: 35px;

  @media (min-width: 992px) {
    margin-top: 75px;
  }
`;

const Section2 = styled.div`
  margin-top: 15px;

  @media (min-width: 992px) {
    margin-top: 30px;
  }
`;

const IndiaAIFestivalPage2025 = () => {
  const { t } = useTranslation();

  const year = 2025;
  const config = {
    awards: {
      groups: [
        {
          title: t("national_awards_title"),
          categories: [
            {
              title: t("impact_festival_2025.impact_creators_title"),
              items: [
                {
                  description: t(
                    "impact_festival_2025.impact_creators_list_item"
                  ),
                },
              ],
            },
            {
              title: t("impact_festival_2025.impact_shapers_title"),
              items: [
                {
                  description: t(
                    "impact_festival_2025.impact_shapers_list_item_1"
                  ),
                },
              ],
            },
            {
              title: t("impact_festival_2025.impact_nurturers_title"),
              items: [
                {
                  description: t(
                    "impact_festival_2025.impact_nurturers_list_item_1"
                  ),
                },
              ],
            },
          ],
        },
        {
          title: t("impact_festival_2025.special_awards_title"),
          categories: [
            {
              title: t("impact_festival_2025.nari_shakti_title"),
              items: [
                {
                  description: t("impact_festival_2025.nari_shakti_list_item"),
                },
              ],
            },
            {
              title: t("impact_festival_2025.aiot_title"),
              items: [
                { description: t("impact_festival_2025.aiot_list_item") },
              ],
            },
            {
              title: t("impact_festival_2025.districts_title"),
              items: [
                { description: t("impact_festival_2025.district_list_item") },
              ],
              note: {
                text: t("aspirational_districts_info"),
                linkText: t("aspirational_districts_link"),
                url: "https://www.niti.gov.in/sites/default/files/2023-07/List-of-112-Aspirational-Districts%20%281%29.pdf",
              },
            },
            {
              title: t("impact_festival_2025.industry_title"),
              items: [
                { description: t("impact_festival_2025.industry_list_item") },
              ],
            },
          ],
        },
      ],
    },
  };

  return (
    <>
      {isSubmissionOpen(year) && (
        <IndiaAIFestivalRedirectionPopUp year={year} />
      )}

      {localStorage.getItem("jwtToken") == null ? (
        <Header hideSubHeader />
      ) : (
        <SecondHeader hideSubHeader />
      )}

      <div className="festival-section gray-light-bg">
        <div class="d-flex justify-content-center w-100">
          <BlinkingNode>
            <IndiaAIFestivalDeadlineNotice
              deadline={formatDateToDDMMMYYYY(SUBMISSION_END_TIMES[year])}
              year={year}
            />
          </BlinkingNode>
        </div>
        <div className="container d-flex justify-content-end">
          <LanguageSwitcher />
        </div>
        <div className="blog-container shadow px-0 pt-0 mt-0">
          <div className="mar-t-15">
            <IndiaAIFestivalBanner year={year} />
          </div>

          <div className="container">
            <Section2>
              <IndiaAIFestivalProjectShowcase year={year} />
            </Section2>
          </div>

          <Section>
            <IndiaAIFestivalTarget />
          </Section>

          <div className="container">
            {/* <Section className="px-md-2 px-xl-5 mx-auto">
              <IndiaAIFestivalOpportunity />
            </Section> */}

            <Section className="px-md-2 px-xl-5 mx-auto">
              <IndiaAIFestivalSpecialAwards
                title={t("special_awards_title")}
                data={config.awards}
              />
            </Section>

            <Section className="px-md-2 px-xl-5 mx-auto">
              <IndiaAIFestivalHowToParticipate year={year} />
            </Section>

            <Section className="px-md-2 px-xl-5 mx-auto">
              <IndiaAIFestivalSubmissionGuidelines />
            </Section>

            <Section className="px-md-2 px-xl-5 mx-auto">
              <IndiaAIFestivalComponents />
            </Section>

            <Section className="px-md-2 px-xl-5 mx-auto">
              <IndiaAIFestivalTimeline year={year} />
            </Section>

            <Section className="px-md-2 px-xl-5 mx-auto">
              <IndiaAIFestivalGuidelines year={year} />
            </Section>

            <Section className="px-md-2 px-xl-5 mx-auto">
              <IndiaAIFestivalContact year={year} />
            </Section>
            <Section className="px-md-2 px-xl-5 mx-auto">
              <ATLTinckerpreneurDisclaimer />
            </Section>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default IndiaAIFestivalPage2025;
